import React from 'react'
import { getImages } from '../const'

const LoadingModal = () => {
    return (
        <>
            <div className="modal-content p-0">
                <div className='loading-box py-5'>
                    <div className='lb-box'>
                        <div className="sm-title text-center fw-600">Loading</div>
                        <div className="float-points">
                            <div className="dot-collision"></div>
                        </div>
                        <div className='text-center gears-icon mt-4 mb-4'>
                            <img src={getImages('loading-red.svg')} alt='loading' />
                        </div>
                        <div className='xs-title text-center opacity-0-8'>This may take upto 10 seconds.<br />
                            Please don't refresh the browser.</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoadingModal